export interface StepAccessOptions {
  stepCount: number;
  furthestStep: number;
  isStepComplete: (stepIndex: number) => boolean;
}

/** Index of the first step still missing required data, or -1 when every step is complete. */
export const getFirstIncompleteStep = ({ stepCount, isStepComplete }: Pick<StepAccessOptions, 'stepCount' | 'isStepComplete'>): number => {
  for (let stepIndex = 0; stepIndex < stepCount; stepIndex += 1) {
    if (!isStepComplete(stepIndex)) return stepIndex;
  }
  return -1;
};

export const areAllStepsComplete = (options: Pick<StepAccessOptions, 'stepCount' | 'isStepComplete'>): boolean => getFirstIncompleteStep(options) === -1;

export const getMaxSelectableStep = ({ stepCount, furthestStep, isStepComplete }: StepAccessOptions): number => {
  const firstIncompleteStep = getFirstIncompleteStep({ stepCount, isStepComplete });
  return firstIncompleteStep === -1 ? furthestStep : Math.min(furthestStep, firstIncompleteStep);
};

export const canSelectStep = (stepIndex: number, options: StepAccessOptions): boolean => stepIndex <= getMaxSelectableStep(options);
